import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { TrackingFieldDto } from 'src/app/types/dto/tracking-field.dto'
import { environment } from 'src/environments/environment'
import { AuthService } from '../auth.service'
import { HttpHelperService } from '../http.service'
import { TimedCache } from '../timed-cache'

@Injectable({
  providedIn: 'root',
})
export class TrackingFieldsApiService {
  private httpHelper = inject(HttpHelperService);
  private auth = inject(AuthService);
  private http = inject(HttpClient);

  private cache = new TimedCache<TrackingFieldDto[]>()

  getNumericTrackingFields(): Observable<TrackingFieldDto[]> {
    const compId = this.auth.getCurrentCompany()?.id ?? 0
    return this.cache.get(`${compId}_numericTrackingFields`, () =>
      this.http.get<TrackingFieldDto[]>(
        environment.apiUrl + 'tracking-fields-for-charts?numericOnly=true',
        this.httpHelper.httpReadOnlyOptions
      )
    )
  }

  getTrackingFieldDisplayName(dataField: string): Observable<string> {
    return this.getNumericTrackingFields().pipe(
      map((fields) => fields.find((f) => f.dataField === dataField)?.displayName ?? dataField)
    )
  }
}
